import React, { useState } from 'react';

import { showToast } from '@opendoor/bricks/complex/Toast';
import { Button, Flex, Text } from '@opendoor/bricks/core';

import { useListingPresentationScheduled } from '../../graphql/athena/mutations/ListingPresentationScheduled';
import { isValidDateForLwc } from '../../routes/LwcDashboard/utils';

type ListingPresentationScheduledFormProps = {
  lwcProductId: string;
};

/** Transitions the state of the lwc product to listing_presentation_scheduled */
export const ListingPresentationScheduledForm: React.FC<ListingPresentationScheduledFormProps> = ({
  lwcProductId,
}) => {
  const handleDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputDate = e.target.value;
    setFormData(inputDate);
  };

  const [formData, setFormData] = useState('');

  const isValidDate = isValidDateForLwc(formData);
  const isoDate = isValidDate ? new Date(formData).toISOString() : '';

  const { setListingPresentationScheduled, error, loading } = useListingPresentationScheduled();

  const handleListingPresentationScheduled = async (date: string) => {
    setListingPresentationScheduled(lwcProductId, date)
      .then(() => {
        showToast(
          'info',
          'Successfully set listing presentation scheduled',
          'lwc-dashboard-toast',
          {
            toastOptions: { autoClose: 3000 },
          },
        );
      })
      .catch((_) => {});
  };
  if (error) {
    showToast('error', 'Error setting listing presentation scheduled', 'lwc-dashboard-toast', {
      toastOptions: { autoClose: false },
    });
  }
  return (
    <Flex flexDirection="column">
      <Text>Listing presentation scheduled</Text>
      <input type="date" value={formData} onChange={handleDateChange} />

      <Button
        my={3}
        aria-label="Submit listing presentation scheduled"
        analyticsName="set-listing-presentation-scheduled"
        onClick={() => handleListingPresentationScheduled(isoDate)}
        disabled={!isValidDate || loading}
        loading={loading}
      >
        Listing presentation scheduled
      </Button>
    </Flex>
  );
};
